import {CardHole, HoleType} from "./CardBacks";

export class HoleCutter {

  constructor() {
  }

  cutHole(hole: CardHole, ctx: any, canvasWidth: number, canvasHeight: number) {
    console.log("Cut hole: ", hole);
    ctx.globalCompositeOperation = 'destination-out';
    this.clipSquare(hole, ctx);
    switch(hole.type) {
      case HoleType.circle:
        this.clipCircle(hole, ctx);
        break;
      case HoleType.square:
        this.clipSquare(hole, ctx);
        break;
      case HoleType.diamond:
        this.clipDiamond(hole, ctx);
        break;
      case HoleType.star:
        this.clipStar(hole, ctx);
        break;
      case HoleType.triangle:
        this.clipTriangle(hole, ctx);
        break;
      case HoleType.heart:
        this.clipHeart(hole, ctx);
        break;
      case HoleType.spade:
        this.clipSpade(hole, ctx);
        break;
      case HoleType.club:
        this.clipClub(hole, ctx);
        break;
      default: //Nothing to do here
        return;
    }
    ctx.clip();
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);
    ctx.globalCompositeOperation = 'source-over';
    ctx.filter = "none";
  }

  clipSquare(hole: CardHole, ctx: any) {
    ctx.beginPath();
    ctx.moveTo(hole.xPos, hole.yPos);
    ctx.lineTo(hole.xPos + hole.wPos, hole.yPos);
    ctx.lineTo(hole.xPos + hole.wPos,hole.yPos + hole.hPos);
    ctx.lineTo(hole.xPos, hole.yPos + hole.hPos);
    ctx.closePath();
  }

  clipCircle(hole: CardHole, ctx: any) {
    ctx.beginPath();
    ctx.ellipse(hole.xPos + (hole.wPos / 2), hole.yPos + (hole.hPos / 2), hole.wPos / 2, hole.hPos / 2, Math.PI, 0, 2 * Math.PI);
  }

  clipDiamond(hole: CardHole, ctx: any) {
    ctx.beginPath();
    ctx.moveTo(hole.xPos + (hole.wPos / 2), hole.yPos);
    ctx.lineTo(hole.xPos + hole.wPos, hole.yPos + (hole.hPos / 2));
    ctx.lineTo(hole.xPos + (hole.wPos / 2),hole.yPos + hole.hPos);
    ctx.lineTo(hole.xPos, hole.yPos + (hole.hPos / 2));
    ctx.closePath();
  }

  clipTriangle(hole: CardHole, ctx: any) {
    ctx.beginPath();
    ctx.moveTo(hole.xPos + (hole.wPos / 2), hole.yPos);
    ctx.lineTo(hole.xPos + hole.wPos, hole.yPos + hole.hPos);
    ctx.lineTo(hole.xPos,hole.yPos + hole.hPos);
    ctx.closePath();
  }

  clipHeart(hole: CardHole, ctx: any) {
    ctx.beginPath();
    var x = hole.xPos;
    var y = hole.yPos;
    ctx.moveTo(x + (hole.wPos * (75/150)), y + (hole.hPos * (30/150)));
    ctx.bezierCurveTo(x + (hole.wPos * (75/150)), y + (hole.hPos * (30/150)),
      x + (hole.wPos * (65/150)), y + (hole.hPos * (0/150)),
      x + (hole.wPos * (40/150)), y + (hole.hPos * (0/150)));
    ctx.bezierCurveTo(x + (hole.wPos * (0/150)), y + (hole.hPos * (0/150)),
      x + (hole.wPos * (0/150)), y + (hole.hPos * (50/150)),
      x + (hole.wPos * (0/150)), y + (hole.hPos * (50/150)));
    ctx.bezierCurveTo(x + (hole.wPos * (0/150)), y + (hole.hPos * (80/150)),
      x + (hole.wPos * (35/150)),y + (hole.hPos * (115/150)),
      x + (hole.wPos * (75/150)), y + (hole.hPos * (150/150)));
    ctx.bezierCurveTo(x + (hole.wPos * (125/150)), y + (hole.hPos * (115/150)),
      x + (hole.wPos * (150/150)), y + (hole.hPos * (80/150)),
      x + (hole.wPos * (150/150)), y + (hole.hPos * (50/150)));
    ctx.bezierCurveTo(x + (hole.wPos * (150/150)), y + (hole.hPos * (50/150)),
      x + (hole.wPos * (150/150)), y + (hole.hPos * (0/150)),
      x + (hole.wPos * (115/150)), y + (hole.hPos * (0/150)));
    ctx.bezierCurveTo(x + (hole.wPos * (85/150)), y + (hole.hPos * (0/150)),
      x + (hole.wPos * (75/150)), y + (hole.hPos * (30/150)),
      x + (hole.wPos * (75/150)), y + (hole.hPos * (30/150)));
    ctx.closePath();
  }

  clipSpade(hole: CardHole, ctx: any) {
    ctx.beginPath();
    var width = hole.wPos;
    var height = hole.hPos;
    var x = hole.xPos + (hole.wPos / 2);
    var y = hole.yPos;
    var bottomWidth = width * 0.7;
    var topHeight = height * 0.7;
    var bottomHeight = height * 0.3;

    ctx.beginPath();
    ctx.moveTo(x, y);

    // top left of spade
    ctx.bezierCurveTo(
      x, y + topHeight / 2, // control point 1
      x - width / 2, y + topHeight / 2, // control point 2
      x - width / 2, y + topHeight // end point
    );

    // bottom left of spade
    ctx.bezierCurveTo(
      x - width / 2, y + topHeight * 1.3, // control point 1
      x, y + topHeight * 1.3, // control point 2
      x, y + topHeight // end point
    );

    // bottom right of spade
    ctx.bezierCurveTo(
      x, y + topHeight * 1.3, // control point 1
      x + width / 2, y + topHeight * 1.3, // control point 2
      x + width / 2, y + topHeight // end point
    );

    // top right of spade
    ctx.bezierCurveTo(
      x + width / 2, y + topHeight / 2, // control point 1
      x, y + topHeight / 2, // control point 2
      x, y // end point
    );

    ctx.moveTo(x, y + topHeight);
    ctx.quadraticCurveTo(
      x, y + topHeight + bottomHeight, // control point
      x - bottomWidth / 2, y + topHeight + bottomHeight // end point
    );
    ctx.lineTo(x + bottomWidth / 2, y + topHeight + bottomHeight);
    ctx.quadraticCurveTo(
      x, y + topHeight + bottomHeight, // control point
      x, y + topHeight // end point
    );
    ctx.closePath();
  }

  clipClub(hole: CardHole, ctx: any) {
    ctx.beginPath();
    var x = hole.xPos + (hole.wPos / 2);
    var y = hole.yPos;
    var height = hole.hPos;
    var width = hole.wPos;
    var circleRadiusX = hole.wPos * 0.3;
    var circleRadiusY = hole.hPos * 0.2;
    var bottomWidth = hole.wPos * 0.5;
    var bottomHeight = hole.hPos * 0.35;
    // top circle
    ctx.ellipse(
      x, y + (hole.hPos * 0.30),
      circleRadiusX, circleRadiusY, 0, .5 * Math.PI, 2.5 * Math.PI, false
    );
    ctx.ellipse(
      x + (hole.wPos * 0.25), y + (height * 0.6),
      circleRadiusX, circleRadiusY, 0, Math.PI, 3 * Math.PI, false
    );
    ctx.ellipse(
      x - (hole.wPos * 0.25), y + (height * 0.6),
      circleRadiusX, circleRadiusY, 0, 0, 2 * Math.PI, false
    );
    ctx.ellipse(
      x, y + (height * 0.5),
      circleRadiusX / 2, circleRadiusY / 2, 0, 0, 2 * Math.PI, false
    );

    // bottom of club
    ctx.moveTo(x, y + (height * 0.6));
    ctx.quadraticCurveTo(
      x, y + height,
      x - bottomWidth / 2, y + height
    );
    ctx.lineTo(x + bottomWidth / 2, y + height);
    ctx.quadraticCurveTo(
      x, y + height,
      x, y + (height * 0.6)
    );
    ctx.closePath();
  }

  clipStar(hole: CardHole, ctx: any) {
    var points = [ [ 0, 85 ], [ 75, 75 ], [ 100, 10 ], [ 125, 75 ],
      [ 200, 85 ], [ 150, 125 ], [ 160, 190 ], [ 100, 150 ],
      [ 40, 190 ], [ 50, 125 ], [ 0, 85 ] ];

    var len = points.length;

    ctx.beginPath();
    ctx.moveTo(hole.xPos + (hole.wPos * (points[0][0] / 190)), hole.yPos + (hole.hPos * (points[0][1] / 190)));

    for (var i = 0; i < len; i++) {
      ctx.lineTo(hole.xPos + (hole.wPos * (points[i][0] / 190)), hole.yPos + (hole.hPos * (points[i][1] / 190)));
    }
    ctx.closePath();
  }

}
